import { DataActionTypes } from "../actions/actiontypes";
import * as LocalStorage from "../../../utils/localStorage";
const intialState = {
    data:LocalStorage.getLSValue("dashBoardData") || null
}

export const dashboardReducer = (state=intialState,action)=>{
    switch(action.type){
        case DataActionTypes.set_DashboardData:{
            return {...state,data:action.payload}
        }
        default:
            return state
    }
}